import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import {
    TablePagination,
    TableFooter,
    Button,
    Stack,
    Typography,
    TableBody,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    tableCellClasses
} from '@mui/material';
import { fetchMyInvitation, updateInviation } from '../../paymentRequest';
import { useDispatch } from 'react-redux';
import { hideApiLoader, showApiLoader } from '../../../redux/tool-webjam/actions';
import moment from 'moment';
import { usePrevious } from '../../Utils';
import toast from 'react-simple-toasts';
import { messages } from '../../messages';
import { ct, dynamicMessageLocale } from '../../../constant-Utils';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "var(--theme-primary-color)",
        color: theme.palette.common.white,
        fontSize: 16,

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

function InvitationList(props) {

    const [page, setPage] = useState(0);

    const [pageNo, setPageNo] = useState({
        currentPage: 0,
        nextPage: 0,
        prevPage: 0
    });

    const [totalRecord, setTotalRecord] = useState(0)
    const [recordPerPage, setRecordPerPage] = useState(10)
    const [list, setList] = useState([])
    const dispatch = useDispatch();


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event) => {
        const { target } = event;
        setRecordPerPage(+target.value);
        setPage(0);
    }

    useEffect(() => {
        fetchData()
    }, [])


    // Page change pagination
    const prevPage = usePrevious(page);
    useEffect(() => {
        let p = 0;
        if (prevPage != undefined && prevPage < page) {
            p = pageNo.nextPage;
        } else if (prevPage != undefined && prevPage > page) {
            p = pageNo.prevPage;
        }
        if (prevPage != undefined && p > 0) {
            fetchData('', "?page=" + p + "&limit=" + recordPerPage)
        }
    }, [page])

    const fetchData = (data = {}, pagination = "?page=1&limit=10") => {
        dispatch(showApiLoader())

        fetchMyInvitation(data, pagination)
            .then(res => {
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    let data = res.data.data;
                    if (data.invite.length) {
                        setList(data.invite)
                        setTotalRecord(data.pagination.count)
                        setRecordPerPage(data.pagination.page.perPage)
                        setPageNo(data.pagination.page)
                    }

                }
            })
    }

    // type 1 is accept, 0 is for reject
    const handleInviteAction = (id, type) => {
        dispatch(showApiLoader())

        updateInviation(id + "/" + (type == 1 ? "accept" : "reject"))
            .then(async res => {
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    fetchData('', "?page=" + pageNo.currentPage)
                    let msg = await dynamicMessageLocale(res.data.message);
                    toast(msg)
                } else {
                    if (res.data?.message) {
                        let msg = await dynamicMessageLocale(res.data?.message);
                        toast(msg)
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"))
                    }
                }
            })
    }

    return (
        <>
            <div
                className='payment-table-common-cont'
            >
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>{ct("rta-trmc.premeeting.meetingName")}</StyledTableCell>
                                <StyledTableCell>{ct("rta-trmc.dashboard.otherRoom.hostName")}</StyledTableCell>
                                <StyledTableCell>{ct("rta-trmc.dashboard.myRecording.startTime")}</StyledTableCell>
                                <StyledTableCell>{ct("rta-trmc.dashboard.otherRoom.action")}</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((row, i) => (
                                <StyledTableRow key={(row._id)}>
                                    <StyledTableCell>{row.groupName}</StyledTableCell>
                                    <StyledTableCell>{row.userName}</StyledTableCell>
                                    <StyledTableCell>{row.startDate ? moment(row.startDate).format("YYYY-MM-DD hh:mm") : "-"}</StyledTableCell>
                                    <StyledTableCell>
                                        <Stack direction="row" spacing={2}>
                                            {
                                                row.status == "pending" ? <>
                                                    <Button variant="contained"
                                                        className="p-theme-btn"
                                                        sx={{
                                                            fontSize: 14
                                                        }}
                                                        onClick={() => handleInviteAction(row._id, 1)}
                                                    >{ct("Translate.buttonTitle.accept")}</Button>
                                                    <Button variant="outlined"
                                                        className="p-theme-outline-btn"
                                                        sx={{
                                                            fontSize: 14
                                                        }}
                                                        onClick={() => handleInviteAction(row._id, 0)}
                                                    >{ct("Translate.buttonTitle.decline")}</Button>
                                                </> : <>
                                                    <Typography>
                                                        {
                                                            row.status == "accept" ? ct("Translate.buttonTitle.accepted") : ct("Translate.buttonTitle.rejected")
                                                        }
                                                    </Typography>
                                                </>
                                            }
                                        </Stack>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50]}
                                    count={totalRecord}
                                    rowsPerPage={recordPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    sx={{
                                        fontSize: 16
                                    }}
                                    SelectProps={{
                                        MenuProps: { classes: { paper: "invite-pagination" } }
                                    }}
                                    className="invite-pagination"
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
}


export default InvitationList;